import { render } from "./RegisterFormView.vue?vue&type=template&id=ccca1060&lang=pug"
import script from "./RegisterFormView.vue?vue&type=script&lang=js"
export * from "./RegisterFormView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__